export const SCOPE = "modules/user/auth/";

export const SIGN_IN = SCOPE + "SIGN_IN";
export const MANUAL_SIGN_IN = SCOPE + "MANUAL_SIGN_IN";
export const LINKEDIN_SIGN_IN = SCOPE + "LINKEDIN_SIGN_IN";
export const SIGN_UP = SCOPE + "SIGN_UP";
export const INSIDER_SIGN_UP = SCOPE + "INSIDER_SIGN_UP";
export const SIGN_OUT = SCOPE + "SIGN_OUT";
export const RESET_PASSWORD = SCOPE + "RESET_PASSWORD";
export const SET_PASSWORD = SCOPE + "SET_PASSWORD";
export const AUTHENTICATION_REDIRECT = SCOPE + "AUTHENTICATION_REDIRECT";
export const UNAUTHENTICATION_REDIRECT = SCOPE + "UNAUTHENTICATION_REDIRECT";
export const FETCH_USER_DATA = SCOPE + "FETCH_USER_DATA";
export const GET_DISCOUNT_INFOS = SCOPE + "GET_DISCOUNT_INFOS";
export const CHECK_USER_DISCOUNT = SCOPE + "CHECK_USER_DISCOUNT";



// WEBPACK FOOTER //
// ./src/modules/user/auth/types.js